import { createActionsHook } from 'src/lib/sweetState';

import { SavedDocumentViewStore } from './SavedDocumentViewStore';

export const useSavedDocumentViewActions = createActionsHook(SavedDocumentViewStore);
